import React, { useEffect, useRef } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, TextField } from '@material-ui/core';

function SearchBar({ value, placeholder, onChange, onCancelSearch, style }) {
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
      const length = inputRef.current.value.length;
      inputRef.current.setSelectionRange(length, length);
    }
  }, [value]);

  return (
    <form
      style={{
        position: 'relative',
        display: 'inline-block',
        ...style,
      }}
      onSubmit={(e) => {
        e.preventDefault();
      }}
    >
      <SearchIcon style={{ position: 'absolute', left: 15, top: 10, fontSize: '25px', marginTop: '5px' }} />
      {value && (
        <IconButton style={{ position: 'absolute', right: 1, top: 3, zIndex: 2 }} onClick={onCancelSearch}>
          <CloseIcon style={{ color: 'black', fontSize: '25px' }} />
        </IconButton>
      )}
      {!value && (
        <div
          style={{
            pointerEvents: 'none',
            color: '#000 !important',
            fontSize: '16px',
            fontWeight: '500',
            lineHeight: '17px',
            position: 'absolute',
            top: 20,
            left: 50,
          }}
        >
          {placeholder}
        </div>
      )}
      <TextField
        id={'search-input'}
        value={value}
        inputRef={inputRef}
        autoFocus
        style={{ position: 'absolute', top: 12, left: 50, overflow: 'hidden', width: '92%' }}
        onChange={(e) => onChange(e.target.value)}
        InputProps={{
          disableUnderline: true,
          style: {
            color: '#000 !important',
            fontSize: '18px',
            fontWeight: '500',
            paddingRight: value ? '50px' : '16px',
          },
        }}
      />
    </form>
  );
}

export default SearchBar;
